<app-multi-select-btn 
    [label]="'Task Types'"
    [list]="templatedTaskItems"
    [selected]="selected"
    (onClosed)="closedEvent($event)">
</app-multi-select-btn>
